import type { ReactNode } from 'react';

interface DialogShellProps {
  isOpen: boolean;
  onClose: () => void;
  titleId: string;
  title: string;
  children: ReactNode;
}

export function DialogShell({
  isOpen,
  onClose,
  titleId,
  title,
  children,
}: DialogShellProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <h2 id={titleId} className="text-xl font-bold text-near-black mb-4">
          {title}
        </h2>
        {children}
      </div>
    </div>
  );
}
